import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import {
  Paper,
  CircularProgress,
  Typography,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  TableFooter,
  TablePagination,
} from '@material-ui/core';

class PaymentsDueTable extends Component {
  static propTypes = {
    loading: PropTypes.bool,
    data: PropTypes.arrayOf(
      PropTypes.shape({
        uuid: PropTypes.string,
        username: PropTypes.string,
        email: PropTypes.string,
        amount: PropTypes.string,
      }),
    ),
    onItemClick: PropTypes.func,
    loadMore: PropTypes.func,
    totalCount: PropTypes.number,
    classes: PropTypes.object.isRequired,
  };

  static defaultProps = {
    data: [],
    loading: false,
    onItemClick: () => {},
    loadMore: () => {},
    totalCount: 0,
  };

  state = {
    page: 0,
    rowsPerPage: 10,
    rowsPageOptions: [],
  };

  handleChangePage = (e, page) => {
    const { loadMore } = this.props;
    const { rowsPerPage } = this.state;

    this.setState({ page });
    loadMore(rowsPerPage);
  };

  renderRows = () => {
    const { data, classes, onItemClick } = this.props;

    const { page, rowsPerPage } = this.state;

    return data
      .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
      .map(payment => (
        <TableRow
          hover
          key={payment.uuid}
          onClick={() => onItemClick(payment)}
          classes={{ hover: classes.tableRow }}
        >
          <TableCell className={classes.tableCell}>{`@${payment.username}`}</TableCell>
          <TableCell className={classes.tableCell}>{payment.email}</TableCell>
          <TableCell className={classes.tableCell}>{payment.amount}</TableCell>
        </TableRow>
      ));
  };

  renderContent = () => {
    const { data, loading, classes } = this.props;

    switch (true) {
      case loading:
        return (
          <TableRow>
            <TableCell colSpan={3} padding="none" className={classes.loading}>
              <CircularProgress thickness={5} size={80} />
            </TableCell>
          </TableRow>
        );
      case !data.length:
        return (
          <TableRow>
            <TableCell colSpan={3} padding="none" className={classes.loading}>
              <Typography variant="display1">
                Sorry, seems there&apos;s no content to display
              </Typography>
            </TableCell>
          </TableRow>
        );
      default:
        return this.renderRows();
    }
  };

  render() {
    const { totalCount, classes } = this.props;
    const { rowsPageOptions, rowsPerPage, page } = this.state;

    return (
      <Paper>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell className={classes.tableHead}>Influencer</TableCell>
              <TableCell className={classes.tableHead}>Email</TableCell>
              <TableCell className={classes.tableHead}>Amount</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>{this.renderContent()}</TableBody>
          <TableFooter>
            <TableRow>
              <TablePagination
                colSpan={3}
                rowsPerPageOptions={rowsPageOptions}
                rowsPerPage={rowsPerPage}
                page={page}
                count={totalCount}
                SelectProps={{ native: true }}
                onChangePage={this.handleChangePage}
              />
            </TableRow>
          </TableFooter>
        </Table>
      </Paper>
    );
  }
}

export default withStyles(theme => ({
  loading: {
    textAlign: 'center',
    padding: `${theme.spacing.unit * 10}px !important`,
  },
  tableHead: {
    fontWeight: 'bold',
    color: theme.palette.primary.main,
  },
  tableCell: {
    border: 'none',
  },
  tableRow: {
    '&&:hover': {
      backgroundColor: theme.palette.action.hover,
    },
  },
}))(PaymentsDueTable);
